"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function StartYourJourney() {
  return <section data-section-id="173705" id="join-the-elite" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32 lg:py-40 flex items-center justify-center min-h-[70vh]">
      {}
      <style>
        {`
          @keyframes shooting-star {
            0% { transform: translateX(-100%); opacity: 0; }
            10% { opacity: 1; }
            70% { opacity: 1; }
            100% { transform: translateX(400%); opacity: 0; }
          }
          .animate-shooting-star {
            animation: shooting-star linear infinite;
          }
        `}
      </style>

      {}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-primary/20 pointer-events-none z-0" />
      
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60vw] h-[60vw] max-w-[800px] max-h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none z-0" />

      {}
      <div className="absolute left-0 top-0 bottom-0 w-1/3 overflow-hidden pointer-events-none z-0 opacity-40 md:opacity-60">
        {[...Array(6)].map((_, i) => <div key={`left-${i}`} data-index={i} className="absolute h-[1px] w-48 sm:w-64 bg-gradient-to-r from-transparent via-primary to-transparent animate-shooting-star" style={{
        top: `${15 + i * 14}%`,
        animationDelay: `${i * 0.8}s`,
        animationDuration: `${3 + i % 3}s`
      }} />)}
      </div>

      {}
      <div className="absolute right-0 top-0 bottom-0 w-1/3 overflow-hidden pointer-events-none z-0 opacity-40 md:opacity-60 rotate-180">
        {[...Array(6)].map((_, i) => <div key={`right-${i}`} data-index={i} className="absolute h-[1px] w-48 sm:w-64 bg-gradient-to-r from-transparent via-primary to-transparent animate-shooting-star" style={{
        top: `${20 + i * 12}%`,
        animationDelay: `${i * 0.5 + 0.3}s`,
        animationDuration: `${2.5 + i % 2}s`
      }} />)}
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center text-center px-6 sm:px-8 max-w-4xl mx-auto">
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tighter mb-6 text-transparent bg-clip-text bg-gradient-to-b from-foreground to-foreground/70 drop-shadow-sm">
          Ready to Master the Markets?
        </h2>
        
        <p className="text-lg sm:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto leading-relaxed font-medium">
          Join TradeSphere today. Experience institutional-grade execution speeds with the precision of advanced cyber-tech trading and uncompromising security.
        </p>

        {}
        <Button asChild size="lg" className="group relative h-16 sm:h-20 px-10 sm:px-14 text-lg sm:text-xl font-bold rounded-sm bg-primary text-primary-foreground overflow-hidden transition-all duration-500 hover:scale-105 hover:shadow-[0_0_40px_-5px_var(--color-primary)] border border-primary/30">
          <Link to="#">
            {}
            <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
            
            <span className="relative z-10 flex items-center gap-3">
              Open Free Account
              <ArrowRight className="size-5 sm:size-6 transition-transform duration-300 group-hover:translate-x-1" />
            </span>
          </Link>
        </Button>
      </div>
    </section>;
}